module.exports = __webpack_public_path__ + "static/Meridian Endodontics Referral Form ABB SBP-422b6794d55775078e78d8eab5271511.pdf";